<template>
    <div class='top-list'>
      <div class="contentBox">

        <div class="titleBox">{{title}}</div>
        <div class="pd25">
          <div style="border-bottom: 2px solid #DDDDDD;padding-bottom: 10px;">
            <div class="dateBox">
              发布时间：{{release}}
            </div>
          </div>
        </div>

        <div class="contentDetail ql-editor">
          <div v-html="richText" class="aabb"></div>

          </div>
  
      
        <div>
  
        </div>
      </div>
      
    </div>
  </template>
  
  <script>
  export default {
    name: 'playlistDetail',
    data() {
    return {
      richText:'',
      title:'',
      release:''

    }
  },
    mounted() {
  const id = this.$route.query.id;
      this.getDetail(id)
} ,methods: {
  getDetail(id){
         this.$API.getDetail({xid:id}).then(res => {
          console.log("hhhhhhhhhhhh11`1",res)
      if (res.code === 200) {
        this.richText = res.data.content
        console.log("22222222222",this.richText)
        this.release = res.data.release
        this.title = res.data.title
        console.log("res===========",res)
      }
    })
    },
    toDetail(xid){
      this.$router.push({path:'/playlistDetail',query: { id: xid }})
    }
  },
  }
  </script>
  
  <style scoped lang='less'>
     ::v-deep .aabb img{
      max-width: 95%;
    }
  //移动端
  @media (max-width: 768px) {
 
    .imgView{
      display: none;
    }
    .dateBox{
font-weight: 500;
font-size: 14px;
color: #7A7A7A;
text-align: left;
font-style: normal;
text-transform: none;
padding-left: 16px;
padding-top: 0 !important;
    }
    .titleBox{
font-weight: 800;
font-size: 24px;
color: #313131;
line-height: 30px;
text-align: left;
font-style: normal;
text-transform: none;
padding:10px;
    }
    .contentDetail{
      padding: 10px;
font-weight: 500;
font-size: 15px;
line-height: 26px;
text-align: left;
font-style: normal;
text-transform: none;
img{
  width: 100%;
}
    }
    .aligCenter{
    display: flex;
    justify-content: center;
  }
    .pd25{
      padding-top: 10px;
    }
    .pcbox{
      display: none;
    }
    .contentBox{
    width: 363px;
    background: #fff;
    margin: 10px auto;
  }
    .imgView{
  width: 323px;
  height: 215px;
  margin-top:10px;
  }
  }
  //pc端
  @media (min-width: 769px) {
    .dateBox{
font-weight: 500;
font-size: 16px;
color: #7A7A7A;
text-align: left;
font-style: normal;
text-transform: none;
    }
  .titleBox{
font-weight: 800;
font-size: 24px;
color: #313131;
text-align: center;
font-style: normal;
text-transform: none;
padding: 37px 0;
  }
    .mobileBox{
      display: none;
    }
    .aligCenter{
    display: flex;
    justify-content: center;
  }
  .contentDetail{
  font-weight: 500;
  font-size: 16px;
  line-height: 30px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  padding: 25px 25px 10px 25px;
  }
  .imgView{
  width: 658px;
  height: 329px;
  }
  
  .pd25{
    padding:0 25px;
  }
  .top-list {
    width: 100%;
    min-height: calc(100vh - 200px);
    margin: 0 auto;
    background-color: #f5f5f5;
    margin-top: 10px;
  
  }
  .contentBox{
    width: 1200px;
    margin: 0 auto;
    min-height: calc(100vh - 200px);
    background: #fff;
    padding-bottom: 80px;
  }
  }
  
  </style>